import axios from 'axios';
import {getItem} from '../utils/storage';
import { getApiDomain } from '../agent/config';
import getV2AxiosInstance from '../utils/v2Axios.js';

export function setOutgoingCalls(data){
    return {
        type: 'SET_OUTGOING_CALLS',
        payload: data
    };
}

export function setIncomingCalls(data){
    return {
        type: 'SET_INCOMING_CALLS',
        payload: data
    };
}

export function setQueuedCalls(data){
    return {
        type: 'SET_QUEUED_CALLS',
        payload: data
    };
}

export function setAutoDialerCalls(data){
  return {
      type: 'SET_AUTO_DIALER_CALLS',
      payload: data
  };
}

export function setScheduledAutoDialerCalls(data){
  return {
      type: 'SET_SCHEDULED_AUTO_DIALER_CALLS',
      payload: data
  };
}

export function updateCallEvents(calls){
  return dispatch => {
    calls.forEach(call => {
      // if((parseInt(call.end_business_id) !== 0) && (call.end_business_id !== undefined)) {
        dispatch( {
          type: 'UPDATE_CALL_EVENTS',
          payload: { 
            id: call.call_id, 
            end_business: call.end_business, 
            end_business_id: call.end_business_id,
            service_id: call.service_id,
            service_name: call.service,
            to: call.destination_phone,
            ...call
           }
        })
      // }
    });
  }
}

function handleResponse(response){
  if(response.status==200){
    return response;
  }else{
    let error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
}

export function getOutgoingCalls(payload){
    const payloadData = payload ? payload : {};
    return (dispatch, getState) => {
      return getV2AxiosInstance()
      .post("/bridge/en/invoxapi/Agent", {
        action: "listOutgoingCallsByAgentId",
        params: { agent_id: localStorage.getItem("agent_id"),
        today_only: 1, 
        time_zone: getState().agentInfo.timezone,
         ...payloadData
       },}).then(data => {
        if(!payload){
          dispatch(setOutgoingCalls(data.data.response.items));
          dispatch(updateCallEvents(data.data.response.items));
        }
        return handleResponse(data);
      });
    };
}

export function getIncomingCalls(payload){
  const payloadData = payload ? payload : {};
    return (dispatch, getState) => {

     return getV2AxiosInstance()
      .post("/bridge/en/invoxapi/Agent", {
        action: "listIncomingCallsByAgentId",
        params: { agent_id: localStorage.getItem("agent_id"),
        today_only: 1, 
        time_zone: getState().agentInfo.timezone,
         ...payloadData
       },
      }).then(data => {
        if(!payload){
          dispatch(setIncomingCalls(data.data.response.items));
          dispatch(updateCallEvents(data.data.response.items));
        }
        return handleResponse(data);
      });
    };
}

export function getQueuedCalls(payload) {
  const payloadData = payload ? payload : {};

  return (dispatch) => {
    return getV2AxiosInstance()
      .post("/bridge/en/invoxapi/Agent", {
        action: "listCallsInQueuesDetail",
        params: {
          agent_id: localStorage.getItem("agent_id"),
          today_only: 1,
          ...payloadData,
        },
      })
      .then((data) => {
        if(data.data.response && data.data.response.items.length > 0)
        if (!payload) {
          dispatch(setQueuedCalls(data.data.response.items[0].calls_in_queue || []));
        }
        return handleResponse(data);
      });
  };
}

export function getAuotoDialerCalls(payload){
    const payloadData = payload ? payload : {};
    return (dispatch, getState) => {
      return getV2AxiosInstance()
      .post("/bridge/en/invoxapi/Agent", {
        action: "listAutodialerCallsByAgentId",
        params: { agent_id: localStorage.getItem("agent_id"),
        today_only: 1, 
        time_zone: getState().agentInfo.timezone,
         ...payloadData
       },
      }).then(data => {
        if(!payload){
          dispatch(setAutoDialerCalls(data.data.response.items));
        }
        return handleResponse(data);
      });
    };
}

export function getScheduledAuotoDialerCalls(){
  return (dispatch) => {
    return getV2AxiosInstance()
      .post("/bridge/en/invoxapi/Agent", {
        action: "listScheduledCalls",
        params: { agent_id: localStorage.getItem("agent_id") },
      })
      .then((data) => {
        dispatch(setScheduledAutoDialerCalls(data.data.response.items));
        return handleResponse(data);
      });
  };
}


// WEBPACK FOOTER //
// ./src/actions/getCalls.js